/**
 * Created by Karol Kluska on 21.06.17.
 */

angular
  .module('app')
  .component('occupancyRoom', {
    templateUrl: 'app/components/offers/panel/occupancy/room/OccupancyRoom.html',
    controller: OccupancyRoom,
    bindings: {
      roomId: '<',
      personsCount: '<',
      categoryCount: '<',
      isDeletable: '<',
      onUpdate: '&',
      onDelete: '&'
    }
  });

function OccupancyRoom(ConfigHotel, ConfigBookingEngine, PROPERTY_TYPE, AGE_CATEGORY, $translate) {
  var $this = this;
  $this.PROPERTY_TYPE = PROPERTY_TYPE;
  $this.AGE_CATEGORY = AGE_CATEGORY;
  $this.$translate = $translate;
  $this.propertyType = ConfigHotel.getPropertyType();
  $this.ageCategories = ConfigBookingEngine.getAgeCategories();
}

OccupancyRoom.prototype = {
  remove: function () {
    this.onDelete({ roomId: this.roomId });
  },

  updatePersonsCount: function (count) {
    this.personsCount = count;
    this.update();
  },

  updateCategoryCount: function (count, index) {
    this.categoryCount[index] = count;
    this.update();
  },

  update: function () {
    this.onUpdate({
      roomId: this.roomId,
      count: this.personsCount,
      categoryCount: this.categoryCount
    });
  },

  getTitle: function () {
    switch (this.propertyType) {
      case this.PROPERTY_TYPE.ROOMS:
        return this.$translate.instant('offers.panel.occupancy.ROOM_FOR');
      case this.PROPERTY_TYPE.APARTMENTS:
        return this.$translate.instant('offers.panel.occupancy.APARTMENT_FOR');
      case this.PROPERTY_TYPE.COTTAGES:
        return this.$translate.instant('offers.panel.occupancy.COTTAGE_FOR');
      default:
        return this.$translate.instant('offers.panel.occupancy.ROOM_FOR');
    }
  }
};
